@if (bewerken()) {
    <div [dlNodeVolger]="node"
         [cy]="cy"
         [ankertype]="labelRechts ? 'rechts' : 'boven'"
         [volgFormaat]="false"
         [schaalMetZoom]="false"
         class="dl-node-label__anker">
        <div class="dl-node-label__box"
             [class.dl-node-label__box--rechts]="labelRechts">
            @if (normOpties(); as opties) {
                <select #invoer
                        class="dl-node-label__veld"
                        [class.dl-node-label__veld--center]="!labelRechts"
                        (change)="kiesNorm($any($event.target).value)">
                    <option [value]="naamNogOpen" [selected]="waarde() === naamNogOpen">{{ naamNogOpen }}</option>
                    @for (optie of opties; track optie.waarde) {
                        <option [value]="optie.waarde" [selected]="waarde() === optie.waarde">{{ optie.label }}</option>
                    }
                </select>
            } @else {
                <input #invoer
                       type="text"
                       class="dl-node-label__veld"
                       [class.dl-node-label__veld--center]="!labelRechts"
                       [value]="waarde()"
                       (input)="waarde.set($any($event.target).value)"
                       (keydown.enter)="bevestigInput()">
            }
        </div>
    </div>
}
